import React, { useEffect } from "react";

import { BikeCompareStorage } from "../../../src/components/BikeCompare/BikeCompareStorage";
import ButtonLink from "../../../src/components/Navigation/ButtonLink";
import MainLayout from "../../../src/components/Layout/MainLayout";
import SeoHead from "../../../src/components/Seo/SeoHead";
import { makeStyles } from "@material-ui/core/styles";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles((theme) => ({
  bikeComparisonOverview: {
    margin: theme.spacing(2),
    marginBottom: theme.spacing(6),
    textAlign: "center",
  },
  headline1: {
    fontSize: 36,
    // marginTop: 0,
    fontFamily: theme.highlightFontFamily,
    fontWeight: 900,
    maxWidth: 900,
    display: "inline-block",
    lineHeight: "1.1",
  },
  content: {
    marginTop: theme.spacing(1),
    textAlign: "left",
    maxWidth: 500,
    width: "100%",
    display: "inline-block",
    fontSize: "medium",
    "& b": {
      fontWeight: 500,
    },
  },
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.palette.background.secondary,
    backgroundColor: theme.openButtonColor,
    fontSize: "large",
  },
  buttonCategory: {
    marginBottom: theme.spacing(12),
    backgroundColor: theme.bikeCompareColor,
    padding: "10px 20px",
  },
  buttonContainer: {
    textAlign: "center",
  },
}));

const Page = (props) => {
  const { flavor } = props;
  const { lang, t } = useTranslation("common");
  const classes = useStyles();
  const router = useRouter();

  //BikeCompareStorage

  useEffect(() => {
    const selectedBikeSeoIds = BikeCompareStorage.getBikes(flavor);
    if (selectedBikeSeoIds && selectedBikeSeoIds.length > 0) {
      const path = selectedBikeSeoIds.join("_vs_");
      const compare_path = flavor == "ebike" ? "ebike-vergleich" : "fahrrad-vergleich";
      router.replace(`/${lang}/${compare_path}/[generic]`, `/${lang}/${compare_path}/${path}`);
    }
  }, [lang, flavor, router]);

  return (
    <MainLayout>
      <SeoHead
        title={t(`bikeComparisonOverviewMetaTitle_${flavor}`)}
        description={t(`bikeComparisonOverviewMetaDescription_${flavor}`)}
        keywords={t(`bikeComparisonOverviewMetaKeywords_${flavor}`)}
        ogImage={
          flavor == "ebike"
            ? "/images/The-Cycleverse-OpenGraph-E-Bike-Vergleich.png"
            : "/images/The-Cycleverse-OpenGraph-Fahrrad-Vergleich.jpg"
        }
        ogDescription={t(`bikeComparisonOverviewMetaDescription_${flavor}`)}
      ></SeoHead>

      <div
        className={classes.bikeComparisonOverview}
        data-test={`page-${flavor == "biobike" ? "fahrrad" : "ebike"}-vergleich`}
      >
        <h1 className={classes.headline1}>{t(`bikeComparisonOverviewTitle_${flavor}`)}</h1>

        <div>
          <img
            loading="lazy"
            src={
              flavor == "ebike"
                ? "https://images.thecycleverse.com/E-Clara-black.svg"
                : "https://images.thecycleverse.com/clara.svg"
            }
            width={60}
            height={55}
            alt="clara"
          />
        </div>

        <div>
          <div className={classes.content}>
            <p>{t(`bikeComparisonOverviewText1_${flavor}`)}</p>
            <p>{t(`bikeComparisonOverviewText1_1_${flavor}`)}</p>
            <p>
              <b>{t(`bikeComparisonOverviewText2_1_${flavor}`)}</b>
              {t(`bikeComparisonOverviewText2_2_${flavor}`)}
              <b>{t(`bikeComparisonOverviewText2_3_${flavor}`)}</b>
              {t(`bikeComparisonOverviewText2_4_${flavor}`)}
            </p>

            <div className={classes.buttonContainer}>
              <ButtonLink
                buttonClassName={`${classes.button} ${classes.buttonCategory}`}
                href="/[...generic]"
                as={flavor == "ebike" ? "/e-bikes" : "/fahrraeder"}
              >
                {t(`bikeComparisonOverviewButtonBikeCategory_${flavor}`)}
              </ButtonLink>
            </div>

            <p>{t(`bikeComparisonOverviewText3_${flavor}`)}</p>

            <div className={classes.buttonContainer}>
              <ButtonLink
                buttonClassName={classes.button}
                href={flavor == "ebike" ? "/welches-ebike-passt-zu-mir" : "/welches-fahrrad-passt-zu-mir"}
                as={flavor == "ebike" ? "/welches-ebike-passt-zu-mir" : "/welches-fahrrad-passt-zu-mir"}
              >
                {t(`bikeComparisonOverviewButtonBikeFinder_${flavor}`)}
              </ButtonLink>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Page;
